var _path, _path2, _path3;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenExternal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.5219 27.2353L36.6644 79.0928L40.9071 83.3354L92.7645 31.478L88.5219 27.2353Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9276 96H34.0701C28.5176 96 23.9976 91.4825 23.9976 85.9275V34.07C23.9976 28.5175 28.5151 23.9975 34.0701 23.9975H45.8551V29.9975H34.0701C31.8251 29.9975 29.9976 31.825 29.9976 34.07V85.9275C29.9976 88.1725 31.8251 90 34.0701 90H85.9276C88.1726 90 90.0001 88.1725 90.0001 85.9275V74.1425H96.0001V85.9275C96.0001 91.48 91.4826 96 85.9276 96Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0001 60H90.0001V34.0725C90.0001 31.8275 88.1726 30 85.9276 30H60.0001V24H85.9276C91.4801 24 96.0001 28.5175 96.0001 34.0725V60Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenExternal);
export default __webpack_public_path__ + "static/media/Open_external.4535652f.svg";
export { ForwardRef as ReactComponent };